﻿import {translation} from "@2d-front-monorepo/core";
import {useInitializeMvvmContext, MvvmButton, MvvmDataProvider, MvvmSwitch} from "@2d-front-monorepo/design-library";
import {CustomData, PermitsMvvmErrorCollector} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback} from "react";
import {useNavigate} from "react-router";
import ChangeUserPassword from "../../content-blocks/UpdatePassword";
import UserData from "../../content-blocks/UserData";
import {getGlobalContext} from "../../hooks/getGlobalContext";
import {getHttpClient} from "../../hooks/getHttpClient";
import {ReloadEntities, reloadPermits} from "../../hooks/reloadPermits";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";

type UpdateUser = {
	email: string
	givenName: string
	familyName: string
	phone: string

	updatePassword: boolean
	oldPassword: string
	password: string
}

export default function Settings(): JSX.Element {
	const global = getGlobalContext();
	const permits = usePermits();
	const navigate = useNavigate();
	const user = permits.holder;
	const isTokenSSO = CustomData.get(user, "authentication") === "token";

	const {context} = useInitializeMvvmContext({
		initialState: () => {
			return {
				email: user.email,
				givenName: user.givenName ?? "",
				familyName: user.familyName ?? "",
				phone: user.cellPhone?.phone ?? "",
				updatePassword: false,
				oldPassword: "",
				password: ""
			}
		}
	});

	const onSubmit = useCallback(async function (data: UpdateUser): Promise<void> {
		const updatePassword = data.updatePassword;
		await getHttpClient().holder.update({
			userInfo: {
				givenName: data.givenName,
				familyName: data.familyName,
				email: data.email,
				phone: {
					countryCode: global.installation.countryId,
					phone: data.phone
				},

				oldPassword: updatePassword ? data.oldPassword : undefined,
				newPassword: updatePassword ? data.password : undefined
			}
		});

		await reloadPermits(ReloadEntities.Holder);
		navigate(PrivateRoutes.permitsHome);
	}, [navigate]);

	return (
		<MvvmDataProvider<UpdateUser> context={context} onSubmit={onSubmit}>
			<h1>{translation(PermitTranslations.settings_page__title)}</h1>
			<hr/>
			<div className="layout vertical gap">
				<PermitsMvvmErrorCollector/>

				<UserData global={global} context={context}/>

				<MvvmSwitch context={context}
				            property="updatePassword"
				            label={translation(PermitTranslations.settings_page__change_password)}
				            hidden={isTokenSSO}/>

				{context.state.updatePassword ? <ChangeUserPassword context={context}/> : undefined}

				<div className="form__buttons">
					<MvvmButton kind="primary">{translation(PermitTranslations.save_changes)}</MvvmButton>
				</div>
			</div>
		</MvvmDataProvider>
	)
}
